import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import DateDataPod from '../../../components/DateDataPod';
import getDeadlineDisplayName from '../../../utils/deadline';
import { getApplicationDeadlines } from '../../TransferMenu/utils';

const TransferApplicationDeadline = ({ transferAdmissions }) => {
  const deadlines = getApplicationDeadlines(get(transferAdmissions, 'deadlines', []));
  const deadline = get(deadlines, '[0]', null);
  const lastUpdated = get(transferAdmissions, 'lastUpdated.value');

  let month = get(deadline, 'month');
  const day = get(deadline, 'day');
  const type = get(deadline, 'type');
  const description = get(deadline, 'description');

  if (typeof month === 'string') {
    month = Number(month);
  }

  const header = type && description && getDeadlineDisplayName({ type, description });

  return deadline ? (
    <DateDataPod
      header={`Transfer ${header}`}
      ariaLabel={`Transfer ${header}, month ${month}, day ${day}`}
      content={{
        value: { month: month - 1, day },
        linkText: 'See all deadlines',
        linkUrl: 'Transfer#application-deadlines',
      }}
      footer={lastUpdated}
    />
  ) : null;
};

TransferApplicationDeadline.propTypes = {
  transferAdmissions: PropTypes.object,
};

export default TransferApplicationDeadline;
